import { render, staticRenderFns } from "./CompleteInfo.vue?vue&type=template&id=6fbff9f6&scoped=true&"
import script from "./CompleteInfo.vue?vue&type=script&lang=js&"
export * from "./CompleteInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompleteInfo.vue?vue&type=style&index=0&id=6fbff9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbff9f6",
  null
  
)

export default component.exports